import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";

// Menu
export interface Menu {
  headTitle?: string;
  headTitle2?: string;
  path?: any;
  title?: string;
  icon?: string;
  type?: string;
  badgeValue?: string;
  badgeClass?: string;
  active?: boolean;
  selected?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  Menusub?: boolean;
  target?: boolean;
  items?: any;
}
@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
      });
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next;
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }
  MENUITEMS: Menu[] = [
    // {
    //   headTitle: "MAIN",
    // },
    // {
    //   title: "Dashboard",
    //   selected: false,
    //   icon: "home",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/dashboard/sales-dashboard",
    //       title: "Sales Dashboard",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/dashboard/marketing-dashboard",
    //       title: "Marketing Dashboard",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/dashboard/app-dashboard",
    //       title: "App Dashboard",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/dashboard/lms-dashboard",
    //       title: "Lms Dashboard",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/dashboard/analytics-dashboard",
    //       title: "Analytics Dashboard",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },
    {
      title: "Dashboard",
      icon: "home",
      type: "link",
      path: "/components/dashboard",
      Menusub: false,
    },
    {
      title: "User Management",
      selected: false,
      icon: "user",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/users",
      children: [
        {
          path: "/components/users/user-detail",
          title: "user",
          type: "link",
          selected: false,
        },
      ],
    },
    {
      title: "Team Management",
      selected: false,
      icon: "lock",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/admin",
      children: [
        {
          path: "/components/admin/admin-detail",
          title: "admin",
          type: "link",
          selected: false,
        },
      ],
    },

    {
      title: "Recruite Management",
      selected: false,
      icon: "list",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/recruite",
      children: [
        {
          path: "/components/recruite/recruite-detail",
          title: "Recruite Management",
          type: "link",
          selected: false,
        },
      ],
    },
    {
      title: "Transaction Management",
      selected: false,
      icon: "credit-card",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/transaction",
      children: [
        {
          path: "/components/transaction/transaction-detail",
          title: "Transaction Management",
          type: "link",
          selected: false,
        },
      ],
    },
    {
      title: "Payments Plans",
      selected: false,
      icon: "credit-card",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/payments",
    },
    {
      title: "Categories",
      selected: false,
      icon: "book",
      type: "sub",
      Menusub: true,
      active: false,
      children: [
        {
          path: "components/categories",
          title: "Category",
          type: "link",
        },
        {
          path: "components/sub-categories",
          title: "Sub-Category",
          type: "link",
        },
      ],
    },
    {
      title: "Notification Management",
      selected: false,
      icon: "bell",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/notifications",
      children: [
        {
          path: "/components/notifications/notifications-detail",
          title: "Notification Management",
          type: "link",
          selected: false,
        },
      ],
    },
    {
      title: "Finance Management",
      selected: false,
      icon: "book",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/finance",
      children: [
        {
          path: "/components/notifications/finance-detail",
          title: "Finance Management",
          type: "link",
          selected: false,
        },
      ],
    },
    {
      title: "Licence Plans",
      selected: false,
      icon: "slack",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/plan",
      children: [
        {
          path: "/components/plan/plan-detail",
          title: "Licence Plans",
          type: "link",
          selected: false,
        },
      ],
    },
    {
      title: "Settings",
      selected: false,
      icon: "settings",
      type: "link", 
      Menusub: false,
      active: false,
      path: "/components/setting",
      children: [
        {
          path: "/components/setting/add-setting",
          title: "Add ",
          type: "link",
          selected: false,
        },
        
      ],

      

    },
    {
      title: "Tax Clause Management",
      selected: false,
      icon: "file",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/tax",
      children: [
        {
          path: "/components/tax/tax-detail",
          title: "Tax Clause Management",
          type: "link",
          selected: false,
        },
      ],
    },
    {
      title: "Tax Clause Approval",
      selected: false,
      icon: "check-square",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/tax-approved",
      children: [
        {
          path: "/components/tax-approved/approved-detail",
          title: "Tax Clause Approval",
          type: "link",
          selected: false,
        },
      ],
    },
    {
      title: "Manage Signup",
      selected: false,
      icon: "user-plus",
      type: "link",
      Menusub: false,
      active: false,
      path: "/components/signup",
      // children: [
      //   {
      //     path: "/components/tax-approved/approved-detail",
      //     title: "Tax Clause Approval",
      //     type: "link",
      //     selected: false,
      //   },
      // ],
    },
    // {
    //   headTitle: "ELEMENTS",
    // },

    // {
    //   title: "Components",
    //   selected: false,
    //   icon: "compass",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/components/cards-design",
    //       title: "Cards design",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/default-calendar",
    //       title: "Default calendar",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/full-calendar",
    //       title: "Full calendar",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/contacts",
    //       title: "Contacts",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/collapse",
    //       title: "collapse",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/default-chat",
    //       title: "Default chat",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/notifications",
    //       title: "Notifications",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/sweet-alerts",
    //       title: "Sweet alerts",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/range-slider",
    //       title: "Range slider",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/content-scroll-bar",
    //       title: "content scroll bar",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/loaders",
    //       title: "Loaders",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/counters",
    //       title: "Counters",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/rating",
    //       title: "Rating",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/timeline",
    //       title: "Timeline",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/components/treeview",
    //       title: "Treeview",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },
    // {
    //   title: "Elements",
    //   selected: false,
    //   icon: "database",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/elements/alerts",
    //       title: "Alerts",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/buttons",
    //       title: "Buttons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/dropdowns",
    //       title: "Dropdowns",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/colors",
    //       title: "Colors",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/avatar-square",
    //       title: "Avatar-Square",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/avatar-rounded",
    //       title: "Avatar-Rounded",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/avatar-radius",
    //       title: "Avatar-Radius",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/list-listgroups",
    //       title: "List&Listgroups",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/tags",
    //       title: "Tags",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/toast",
    //       title: "Toast",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/offcanvas",
    //       title: "Offcanvas",
    //       type: "link",
    //       selected: false,
    //     },

    //     {
    //       path: "/elements/pagination",
    //       title: "Pagination",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/navigation",
    //       title: "Navigation",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/typography",
    //       title: "Typography",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/breadcrumbs",
    //       title: "Breadcrumbs",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/badges",
    //       title: "Badges",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/panels",
    //       title: "Panels",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/elements/thumbnails",
    //       title: "Thumnails",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },
    // {
    //   title: "Advanced UI",
    //   selected: false,
    //   icon: "box",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/advanced-ui/media-object",
    //       title: "Media object",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/accordions",
    //       title: "Accordions",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/tabs",
    //       title: "Tabs",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/modal",
    //       title: "Modal",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/tooltip-and-popover",
    //       title: "Tooltip and popover",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/progress",
    //       title: "Progress",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/carousels",
    //       title: "Carousels",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/footers",
    //       title: "Footers",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/user-list",
    //       title: "User list",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/search",
    //       title: "Search",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/advanced-ui/crypto-currencies",
    //       title: "Crypto-currencies",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },
    // {
    //   headTitle: "ICONS",
    // },
    // {
    //   title: "Icons",
    //   selected: false,
    //   icon: "wind",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/icons/font-awesome",
    //       title: "Font Awesome",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/material-design-icons",
    //       title: "Material Design Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/simple-line-icons",
    //       title: "Simple Line Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/feather-icons",
    //       title: "Feather Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/lonic-icons",
    //       title: "lonic-Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/flag-icons",
    //       title: "Flag Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/pe7icons",
    //       title: "pe7 Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/themify-icons",
    //       title: "Themify Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/typicons-icons",
    //       title: "Typicons Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/weather-icons",
    //       title: "Weather Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/icons/bootstrap-icons",
    //       title: "Bootstrap Icons",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },
    // {
    //   headTitle: "PAGES",
    // },
    // {
    //   title: "Pages",
    //   selected: false,
    //   icon: "layers",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/pages/profile",
    //       title: "Profile",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/pages/gallery",
    //       title: "Gallery",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/pages/about-company",
    //       title: "About Company",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/pages/services",
    //       title: "Services",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/pages/faqs",
    //       title: "FAQS",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/pages/terms",
    //       title: "Terms",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/pages/invoice",
    //       title: "Invoice",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/pages/pricing-tables",
    //       title: "Pricing  Tables",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/pages/settings",
    //       title: "Settings",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       title: "Blog",
    //       selected: false,
    //       icon: "slack",
    //       type: "sub",
    //       Menusub: true,
    //       active: false,
    //       children: [
    //         {
    //           path: "/pages/blog/blog-page",
    //           title: "Blog-page",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/blog/blog-details",
    //           title: "Blog-details",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/blog/blog-post",
    //           title: "Blog-post",
    //           type: "link",
    //           selected: false,
    //         },
    //       ],
    //     },
    //     {
    //       title: "Charts",
    //       selected: false,
    //       icon: "slack",
    //       type: "sub",
    //       Menusub: true,
    //       active: false,
    //       children: [
    //         {
    //           path: "/pages/charts/apexcharts",
    //           title: "Apexcharts",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/charts/chartjs",
    //           title: "Chart-js",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/charts/echarts",
    //           title: "Echarts",
    //           type: "link",
    //           selected: false,
    //         },
    //       ],
    //     },
    //     {
    //       title: "Tables",
    //       selected: false,
    //       icon: "slack",
    //       type: "sub",
    //       Menusub: true,
    //       active: false,
    //       children: [
    //         {
    //           path: "/pages/tables/default-table",
    //           title: "Default table",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/tables/data-tables",
    //           title: "Data tables",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/tables/edit-tables",
    //           title: "Edit tables",
    //           type: "link",
    //           selected: false,
    //         },
    //       ],
    //     },
    //     {
    //       title: "Forms",
    //       selected: false,
    //       icon: "slack",
    //       type: "sub",
    //       Menusub: true,
    //       active: false,
    //       children: [
    //         {
    //           path: "/pages/forms/form-elements",
    //           title: "Form Elements",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/forms/form-layouts",
    //           title: "Form Layouts",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/forms/form-editor",
    //           title: "Form Editor",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/forms/form-wizard",
    //           title: "Form wizard",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/forms/form-validation",
    //           title: "Form Validation",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/forms/form-element-sizes",
    //           title: "Form Element sizes",
    //           type: "link",
    //           selected: false,
    //         },
    //       ],
    //     },
    //     {
    //       title: "File Manager",
    //       selected: false,
    //       icon: "slack",
    //       type: "sub",
    //       Menusub: true,
    //       active: false,
    //       children: [
    //         {
    //           path: "/pages/file-manager/file-manager",
    //           title: "File Manager",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/file-manager/file-manager-list",
    //           title: "File Manager List",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/file-manager/file-details",
    //           title: "File Details",
    //           type: "link",
    //           selected: false,
    //         },
    //         {
    //           path: "/pages/file-manager/file-attachments",
    //           title: "File Attachments",
    //           type: "link",
    //           selected: false,
    //         },
    //       ],
    //     },
    //     {
    //       path: "/pages/empty-page",
    //       title: "Empty Page",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },
    // {
    //   headTitle: "E-COMMERCE",
    // },
    // {
    //   title: "E-commerce",
    //   selected: false,
    //   icon: "shopping-cart",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/e-commerce/shop",
    //       title: "Shop",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/e-commerce/product-details",
    //       title: "Product Details",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/e-commerce/shopping-cart",
    //       title: "Shopping Cart",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/e-commerce/add-product",
    //       title: "Add Product",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/e-commerce/wish-list",
    //       title: "Wish List",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/e-commerce/checkout",
    //       title: "Checkout",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },
    // {
    //   headTitle: "CUSTOM & ERROR PAGES",
    // },
    // {
    //   title: "Custom Pages",
    //   selected: false,
    //   icon: "target",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/custom-pages/login",
    //       title: "Login",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/custom-pages/register",
    //       title: "Register",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/custom-pages/forgot-password",
    //       title: "Forgot Password",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/custom-pages/lock-screen",
    //       title: "Lock-screen",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/custom-pages/under-construction",
    //       title: "Under Construction",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },

    // {
    //   title: "Error Pages",
    //   selected: false,
    //   icon: "alert-circle",
    //   type: "sub",
    //   Menusub: true,
    //   active: false,
    //   children: [
    //     {
    //       path: "/error-pages/error400",
    //       title: "error400",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/error-pages/error401",
    //       title: "error401",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/error-pages/error403",
    //       title: "error403",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/error-pages/error404",
    //       title: "error404",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/error-pages/error500",
    //       title: "error500",
    //       type: "link",
    //       selected: false,
    //     },
    //     {
    //       path: "/error-pages/error503",
    //       title: "error503",
    //       type: "link",
    //       selected: false,
    //     },
    //   ],
    // },
  ];
  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
